import axios from 'axios';
import { CallAPIPromise } from './func';
import { setSpinnerLoading } from '../Redux/modal';
import Store from '../Redux/store';
export const low_Bal_alert = 'Insufficient Credits';
export const getEmptyMeasurementList = async (
  uppr_lower,
  masterPrefix,
  token
) => {
  let list = [];
  await CallAPIPromise(`/api/masters/listMeasurementMaster`, {
    table_prefix_master: masterPrefix,
    UPPER_LOWER: uppr_lower,
  })
    .then((res) => {
      if (!res.data.error) {
        if (res.data.response[0]) {
          list = res.data.response.map((res) => {
            return {
              ...res,
              size: '',
            };
          });
        }
        return list;
      } else {
        return list;
      }
    })
    .catch((err) => {
      console.log(err);
      return list;
    });

  return list;
};

export const getMessageWallet = (companyEmail, token, sms) => {
  const dispatch = Store.dispatch;
  return new Promise((resolve, reject) => {
    CallAPIPromise(
      `/api/whatsApp/loadMessageBalance`,
      {
        company_email: companyEmail,
      },
      token,
      dispatch
    )
      .then((res) => {
        if (!res.data.error) {
          if (res.data.response[0]) {
            if (sms) {
              resolve(
                Number(res.data.response[0].sms_balance),
                res.data.response[0]
              );
            } else {
              if (res.data.response[0].whatsapp_balance < 1) {
                dispatch(setSpinnerLoading(false));
              }
              resolve(
                Number(res.data.response[0].whatsapp_balance),
                res.data.response[0]
              );
            }
          } else {
            dispatch(setSpinnerLoading(false));
            resolve(0);
          }
        } else {
          resolve(0);
        }
      })
      .catch((err) => {
        console.log(err);
        reject(0);
      });
  });
};
